<template>
  <div>

    <div>
      <label class="font-weight-bold">Default Maximum Advanced Purchase Period</label>

      <div class="row py-4">
        <div v-for="(item, index) in advanced_options" :key="index">
          <label class="radio radio-gold ml-3">
            <input @click="handleRadioChange(item.value)" type="radio" name="applicableStatus" v-bind:value="item.value"
              v-model="selectedRadio" :disabled="product_id == 14 ? true : false">

            <div class="d-flex flex-row child-flex-class">
              <span>{{ item.name }}</span>
            </div>
            <span class="checkmark"></span>
          </label>
        </div>

        <div class="col-1">
        </div>

        <div v-if="selectedRadio == 0" class="col-7">
          <span class="text-danger font-weight-bold">Note: The 'From Date' in the mobile will be automatically set to
            today's date and will not be editable by users.</span>
        </div>
        <div v-else class="col-7">
          <div class="d-flex flex-row">
            <label class="mr-2 mb-0" style="align-self: center;">Up to:</label>
            <div>
              <input type="number" class="form-control form-control-sm mr-2" style="width: 80px; align-self: center;"
                v-model="defaultValue" />
              <span class="invalid-feedback">{{ defaultPeriodErrors.defaultValue }}</span>
            </div>

            <div>
              <select v-model="defaultType" class="form-control form-control-sm mr-2"
                style="width: 120px; align-self: center;">
                <option v-for="(item, index) in duration_options" :key="index" :value="item.value"
                  :selected="item.value == defaultType">{{ item.name }}</option>
              </select>
              <span class="invalid-feedback">{{ defaultPeriodErrors.defaultType }}</span>
            </div>

            <button class="btn btn-primary btn-sm" style="align-self: center;"
              @click="updateAdvancedPurchase">Update</button>
          </div>
        </div>
      </div>

      <div>
        <label class="font-weight-bold">Maximum Advanced Purchased Period for Promotions</label>
        <div style="margin-left: -15px">

          <TableComponent :data="productDetails" :columns="tableColumns" table_id="advanced-purchased-tbl"
            :showAddbutton="true" />
        </div>
      </div>

      <div>
        <label class="font-weight-bold">Change Logs</label>
        <div style="margin-left: -15px">

          <TableComponent :data="activityLogs" :columns="activityTableColumns" table_id="advanced-logs-tbl" />
        </div>
      </div>

      <Modal @submitPromo="handleSubmission" :duration_options="duration_options" :autoSet="autoSet" :data="data"
        :errors="errors" />

      <ErrorModal :message="errorMessage" />

      <EditModal @updatePromo="handleUpdate" :data="data" :duration_options="duration_options" :errors="errors" />

      <ConfirmationModal @submitConfirmation="handleConfirmed" :message="'Are you sure?'" />
    </div>
  </div>
</template>


<script>
import TableComponent from "../../../components/UI/TableComponent.vue";
import { getAdvancedPromotions, getDefaultValue, getLogs, store, togglePromotionStatus, update, updateDefaultAdvancedPurchase } from "../../../services/DefaultAdvancedPurchaseService";
import Modal from "./add-modal.vue";
import ErrorModal from "./error-modal.vue";
import EditModal from "./edit-modal.vue";
import ConfirmationModal from "./confirmation-modal.vue";
import { data } from "jquery";

export default {
  name: "product-period-page",

  components: {
    TableComponent,
    Modal,
    ErrorModal,
    EditModal,
    ConfirmationModal
  },

  props: {
    product_id: {
      type: String | Number,
      required: true
    }
  },

  data() {
    return {
      selectedRadio: 0,

      advanced_options: [
        { value: 1, name: "Applicable" },
        { value: 0, name: "Not Applicable" },
      ],

      duration_options: [
        { value: 1, name: "Days" },
        { value: 2, name: "Months" },
        { value: 3, name: "Years" },
      ],

      autoSet: {
        6: { value: 60, type: 1 },
        2: { value: 2, type: 2 },
        3: { value: 2, type: 2 },
        4: { value: 3, type: 2 },
        5: { value: 3, type: 2 },
        1: { value: 3, type: 2 },
        7: { value: 2, type: 2 },
        8: { value: 3, type: 2 },
        9: { value: 3, type: 2 },
        10: { value: 3, type: 2 },
      },

      productDetails: [],
      defaultValue: 0,
      defaultType: 1,
      defaultStatus: 0,

      activityLogs: [],

      data: {
        title: '',
        start_date: '',
        end_date: '',
        type: '',
        value: '',
        product_id: this.product_id
      },

      confirmed: false,
      user: JSON.parse(localStorage.getItem("user")),

      errorMessage: 'Only Marketing role is allowed to manage the maximum advanced purchase period for promotions.',

      errors: {
        title: '',
        start_date: '',
        end_date: '',
        type: '',
        value: '',
      },

      defaultPeriodErrors: {
        defaultValue: '',
        defaultType: ''
      }
    }
  },

  watch: {
    productDetails: {
      handler(newProductDetails) {
        this.initializeCurrentTable();
      },
      deep: true
    },
    activityLogs: {
      handler(newActivityLogs) {
        this.initializeCurrentTable();
      },
      deep: true
    },

    data: {
      handler(newData) {
        this.validateErrors();
      },
      deep: true
    },

    defaultValue: {
      handler(newVal, oldVal) {
        this.validateDefaultPeriodErrors();
      }
    },
    selectedRadio: function (newVal, oldVal) {
      if (newVal == 0 && this.defaultStatus == 1) {
        this.updateAdvancedPurchase()
      }
    },
  },

  computed: {
    tableColumns() {
      return [
        {
          header: "No",
          body: (item, index) => index + 1,
          width: '5%'
        },
        {
          header: "Title",
          body: "title", // or function: (item) => item.title
          width: '20%'
        },
        {
          header: "From",
          body: "start_date_formatted",
          width: '15%'
        },
        {
          header: "To",
          body: "end_date_formatted",
          width: '15%'
        },
        {
          header: "Maximum Advanced Purchased Period",
          body: "period",
          width: '25%'
        },
        {
          header: "Action",
          type: "action",
          width: '15%',
          actions: [
            {
              key: "toggle_status",
              label: (item) => item.status ? 'Deactivate' : 'Activate',
              class: (item) => item.status ? 'btn-danger btn-block btn-rounded' : 'btn-success btn-block btn-rounded',
              handler: this.toggleStatus
            },
            {
              key: "edit",
              label: "Edit Detail",
              class: "btn-primary btn-block btn-rounded",
              handler: this.editItem
            }
          ]
        }
      ];
    },

    activityTableColumns() {
      return [
        {
          header: "No",
          body: (item, index) => index + 1,
          width: '5%'
        },
        {
          header: "User",
          body: "name",
          width: '20%'
        },
        {
          header: "Description",
          body: "description",
          width: '15%'
        },
        {
          header: "Timestamp",
          body: "timestamp",
          width: '15%'
        }
      ];
    }
  },

  methods: {
    handleRadioChange(item) {
      this.selectedRadio = item;
    },

    async fetchAdvancedPurchase() {
      try {
        const response = await getAdvancedPromotions(this.product_id);
        if (response.data.success) {
          this.productDetails = response.data.data;
        }
      } catch (error) {
        console.error("Error fetching advanced purchase data:", error);
      }
    },

    async loadDefaultValue() {
      try {
        const response = await getDefaultValue(this.product_id);
        if (response.data.success) {
          this.defaultValue = response.data.data.value;
          this.defaultType = response.data.data.type.value;
          this.defaultStatus = response.data.data.status ? 1 : 0;
          this.selectedRadio = response.data.data.status ? 1 : 0;
        }
      } catch (error) {
        console.error("Error fetching default value:", error);
        this.defaultValue = this.autoSet[this.product_id].value;
        this.defaultType = this.autoSet[this.product_id].type;
      }
    },

    loadDatatable(tableId) {
      if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
        $(`#${tableId}`).DataTable().destroy();
      }

      $(`#${tableId}`).DataTable({
        pageLength: 10,
        dom: "Bfrtip",
        order: [],
        columns: [
          { orderable: false },
          { orderable: false },
          { orderable: false },
          { orderable: false },
          { orderable: false },
          { orderable: false }
        ],
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5],
              modifier: {
                page: 'all'
              }
            }
          }
        ]
      });
    },

    loadDatatable2(tableId) {
      if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
        $(`#${tableId}`).DataTable().destroy();
      }

      $(`#${tableId}`).DataTable({
        pageLength: 10,
        dom: "Bfrtip",
        order: [],
        columns: [
          { orderable: false },
          { orderable: false },
          { orderable: false },
          { orderable: false },
        ],
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3],
              modifier: {
                page: 'all'
              }
            }
          }
        ]
      });
    },

    async fetchActivity() {
      try {
        const response = await getLogs(this.product_id);
        if (response.data.success) {
          this.activityLogs = response.data.data;
        } else {
          this.activityLogs = [];
        }
      } catch (error) {
        console.error("Error fetching activity logs:", error);
      }
    },

    validateErrors() {
      Object.keys(this.errors).forEach(key => {
        this.errors[key] = '';
      });

      // Then add errors for empty fields
      Object.keys(this.data).forEach(key => {
        if (key !== 'product_id' && this.data[key] === '') {
          this.errors[key] = `This field cannot be empty`;
        }
      });

      return this.errors;
    },

    validateDefaultPeriodErrors() {
      this.defaultPeriodErrors.defaultValue = '';
      this.defaultPeriodErrors.defaultType = '';

      // Then add errors for empty fields
      if (this.defaultValue == '') {
        this.defaultPeriodErrors.defaultValue = `This field cannot be empty`;
      }

      return this.defaultPeriodErrors;
    },

    async handleSubmission(formData) {

      let validationErrors = this.validateErrors();

      const hasErrors = Object.values(validationErrors).some(error => error != '');

      if (hasErrors) {
        return;
      }

      let confirmation = await swal({
        icon: "warning",
        text: `Are you sure you want to submit?`,
        buttons: ["Cancel", "Confirm"]
      });

      if (!confirmation) {
        return false;
      }

      try {
        const response = await store(formData);

        if (response.data.success) {
          swal({
            text: response.data.message,
            icon: response.data.success ? "success" : 'error',
            button: "OK",
          });
        }
      } catch (error) {
        $('#add-promo-modal').modal('hide');

        if (error.response && error.response.status == 403) {
          this.errorMessage = error.response.data.message;
          setTimeout(() => {
            $('#error-modal').modal('show');
          }, 450);
        }

        console.error("Error in submission:", error);
      } finally {
        $('#add-promo-modal').modal('hide');
        await this.fetchAdvancedPurchase();
        await this.fetchActivity();
        this.resetForm();
      }
    },

    async handleUpdate(formData) {
      let validationErrors = this.validateErrors();

      const hasErrors = Object.values(validationErrors).some(error => error !== '');

      if (hasErrors) {
        return;
      }

      let confirmation = await swal({
        icon: "warning",
        text: `Are you sure you want to update?`,
        buttons: ["Cancel", "Confirm"]
      });

      if (!confirmation) {
        return false;
      }
      try {
        const response = await update(formData, formData.id);


        if (response.data.success) {
          swal({
            text: response.data.message,
            icon: response.data.success ? "success" : 'error',
            button: "OK",
          });
        }
      } catch (error) {
        $('#edit-promo-modal').modal('hide');

        if (error.response && error.response.status == 403) {
          this.errorMessage = error.response.data.message;
          setTimeout(() => {
            $('#error-modal').modal('show');
          }, 450);
        }

        console.error("Error in submission:", error);
      } finally {
        $('#edit-promo-modal').modal('hide');
        await this.fetchAdvancedPurchase();
        await this.fetchActivity();
      }
    },

    async toggleActiveStatus(request) {
      try {
        const payload = {
          status: request.status ? 0 : 1
        }
        const response = await togglePromotionStatus(request.id, payload);

        if (response.data.success) {
          swal({
            text: response.data.message,
            icon: response.data.success ? "success" : 'error',
          });
        }
      } catch (error) {
        $('#edit-promo-modal').modal('hide');

        if (error.response && error.response.status == 403) {
          this.errorMessage = error.response.data.message;
          setTimeout(() => {
            $('#error-modal').modal('show');
          }, 450);
        }
        console.error("Error toggling active status:", error);
      } finally {
        await this.fetchAdvancedPurchase();
        await this.fetchActivity();
      }
    },

    initializeCurrentTable() {
      ['advanced-purchased-tbl', 'advanced-logs-tbl'].forEach(tableId => {
        if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
          $(`#${tableId}`).DataTable().destroy();
        }
      });

      this.$nextTick(() => {
        this.loadDatatable('advanced-purchased-tbl');
        this.loadDatatable2('advanced-logs-tbl');
      });
    },

    checkCurrentProduct() {

    },

    handleConfirmed() {
      this.confirmed = true;
    },

    async updateAdvancedPurchase() {

      let validationErrors = this.validateDefaultPeriodErrors();
      const hasErrors = Object.values(validationErrors).some(error => error !== '');

      if (hasErrors) {
        return;
      }

      let confirmation = await swal({
        icon: "warning",
        text: `Are you sure you want to update?`,
        buttons: ["Cancel", "Confirm"]
      });

      if (!confirmation) {
        return false;
      }

      try {
        const response = await updateDefaultAdvancedPurchase({
          product_id: this.product_id,
          value: this.defaultValue,
          type: this.defaultType,
          status: this.selectedRadio
        });

        if (response.data.success) {
          swal({
            text: response.data.message,
            icon: response.data.success ? "success" : 'error',
          });

          this.defaultStatus = this.selectedRadio;
        }
      } catch (error) {
        if (error.response && error.response.status == 403) {
          this.errorMessage = error.response.data.message;
          setTimeout(() => {
            $('#error-modal').modal('show');
          }, 450);
        }

        console.error("Error updating advanced purchase:", error);
      } finally {
        await this.fetchAdvancedPurchase();
        await this.fetchActivity();
      }
    },

    async toggleStatus(item, index) {
      // console.log('Toggling status for:', item);

      const hasRole = this.user.roles.some(role => role.name == "Marketing");

      if (!hasRole) {
        $('#error-modal').modal('show');
        return;
      }
      await this.toggleActiveStatus(item);
      // this.$emit('toggle-status', { item, index });
    },

    editItem(item, index) {
      const hasRole = this.user.roles.some(role => role.name == "Marketing");

      if (hasRole) {
        this.data = { ...item, status: item.status ? 1 : 0, product_id: this.product_id };

        // this.$emit('edit-item', { item, index });

        $('#edit-promo-modal').modal('show');
      } else {
        $('#error-modal').modal('show');
      }
    },

    resetForm() {
      this.data = {
        title: '',
        start_date: '',
        end_date: '',
        type: '',
        value: '',
        status: '',
        product_id: this.product_id
      };
    }
  },

  async mounted() {
    await this.fetchAdvancedPurchase();
    await this.loadDefaultValue();
    await this.fetchActivity();

    if (!this.user.roles.some(role => role.name == "Marketing")) {
      this.errorMessage = 'Only Marketing role is allowed to manage the maximum advanced purchase period for promotions.';
    } else if (!this.user.roles.some(role => role.name == "TBA Staff")) {
      this.errorMessage = 'Only TBA role is allowed to manage the default maximum advanced purchase period.';
    }
  }
};
</script>

<style scoped>
.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
</style>
